/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SearchFollowingPressReleaseResponseData,
    SearchFollowingPressReleaseResponseDataFromJSON,
    SearchFollowingPressReleaseResponseDataFromJSONTyped,
    SearchFollowingPressReleaseResponseDataToJSON,
} from './SearchFollowingPressReleaseResponseData';

/**
 * 
 * @export
 * @interface SearchLatestPressReleasesResponse
 */
export interface SearchLatestPressReleasesResponse {
    /**
     * 
     * @type {number}
     * @memberof SearchLatestPressReleasesResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof SearchLatestPressReleasesResponse
     */
    message: string;
    /**
     * 
     * @type {SearchFollowingPressReleaseResponseData}
     * @memberof SearchLatestPressReleasesResponse
     */
    data: SearchFollowingPressReleaseResponseData;
}

export function SearchLatestPressReleasesResponseFromJSON(json: any): SearchLatestPressReleasesResponse {
    return SearchLatestPressReleasesResponseFromJSONTyped(json, false);
}

export function SearchLatestPressReleasesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchLatestPressReleasesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': SearchFollowingPressReleaseResponseDataFromJSON(json['data']),
    };
}

export function SearchLatestPressReleasesResponseToJSON(value?: SearchLatestPressReleasesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': SearchFollowingPressReleaseResponseDataToJSON(value.data),
    };
}

